<template lang="html">
  <d-row class="feed_container">
    <d-col cols="3" v-for="(post, index) in posts" :key="index" >
      <d-card :class="['card-small mb-3', (post.selected) ? 'selected': '' ]" @click="selectPost(post)">
        <d-card-header class="pb-1">
          <h6 class="mb-0">
            {{post.title}}
            <i class="fa fa-bars float-right options cursor-pointer" @click.stop="openOptions(post)"></i>
          </h6>
        </d-card-header>
        <d-card-body>
          <children-media :post="post.children.data" v-if="post.children"></children-media>
          <item-media :post="post" v-else />
        </d-card-body>
        <d-card-footer class="d-flex justify-content-between">
          <span class="float-left"><i class="fa fa-heart"></i> {{ post.like_count }}</span>
          <a class="link" :href="post.permalink" target="_blank"><i class="fa fa-external-link-alt mr-2"></i>Ver original</a>
          <span class="float-right"><i class="fa fa-comment"></i> {{ post.comments_count }}</span>
        </d-card-footer>
      </d-card>
    </d-col>
    <item-tags-modal></item-tags-modal>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ChildrenMedia from './ChildrenMedia.vue';
import ItemMedia from './ItemMedia.vue';
import ItemTagsModal from './modal/ItemTagsModal.vue';
import { _LOAD_FEED_, _LOAD_FEED_TAG_, _CLOSED_FEED_TAG_ } from './FeedModel';

export default {
  name: 'feed-list-items',
  components: {
    ItemMedia,
    ChildrenMedia,
    ItemTagsModal,
  },
  data() {
    return {
      posts: [],
      selected: [],
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    openOptions(post) {
      const params = { array: false, post: { ...post } };
      if (this.selected.length > 1) {
        params.array = true;
        params.post = { ...this.selected };
      }
      Events.$emit(_LOAD_FEED_TAG_, params);
      this.setToggle({ type: 'feed_post_tag_modal', bool: true });
    },
    selectPost(post) {
      post.selected = !post.selected;
      if (post.selected === true) {
        return this.selected.push(post);
      }
      this.selected = this.selected.filter(item => item.id !== post.id);
      return this.selected;
    },
  },
  mounted() {
    Events.$on(_LOAD_FEED_, feed => {
      this.posts = feed;
    });
    Events.$on(_CLOSED_FEED_TAG_, () => {
      this.selected = [];
      this.posts = this.posts.map(item => {
        item.selected = false;
        return item;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.feed_container {
  margin-top: 20px;;
  .card {
    position: relative;
    z-index: 7;
    &.selected {
      background: #b9f2ff;
    }
    .card-header {
      background: transparent;
      h6 {
        height: 24px;
      }
      .options {
        position: relative;
        z-index: 9;
      }
    }
    .card-body {
      position: relative;
      height: 334px;
      align-items: center;
      overflow: hidden;
      display: flex;
    }
    .card-footer {
      background: transparent;
      .link {
        color: inherit;
      }
    }
  }
}
</style>
